// Third-party imports
import $ from 'jquery';

// When run in a browser, global is expected to be the window object
export function initialize(global) {
    let windowWidth = $(global).outerWidth();
    let cartBreakpoint = 1366;
    let stickyCart = $('.orderForm');
    if (windowWidth < cartBreakpoint || !stickyCart.length) {
        return;
    }
    set_alltotal_top(stickyCart);
}

// This function assumes that the order form's top is above (ie less than)
// #basket-items's top
function set_alltotal_top(cart) {
    let cart_top = cart.offset().top;
    let items_top = $('#basket-items').offset().top;
    let new_top = items_top - cart_top;
    cart.css('top', new_top);
}
